import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {ItemComponent} from "../../player/item.component";
import {SceneComponent} from "../scene/scene.component";


@Component({
  selector: 'app-xml-item',
  template: '<div #component></div>',
  styleUrls: []
})
export class CustomRssItemComponent extends ItemComponent {
  constructor(protected  injector: Injector) {
    super(injector);
    this.folder = 'customRss';
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }

        const field = this.data.RssItem[0].$.field;
        if (field=='resource') {
          this.fieldType = 'resource';
          this.fieldName = "media:content.0.$.url";
          this.aspectRatio = this.data.RssItem[0]?.$.maintainAspectRatio == "1";
        } else {
          this.fieldType = 'text';
          this.fieldName = field;
        }


        if (this.data.RssItem[0].Font != null) {
          const font = this.data.RssItem[0].Font[0].$;
          this.genericElm.fontStyle = this.getFontStyle(font);
          return this.playerService.caching.requestFont(font);
        }
      }),
      switchMap(r=> {
        let childProviderData;
        if (this.parentPlayer!= null) {
          childProviderData = (<SceneComponent>this.parentPlayer).childProviderData;
        }
        return this.invalidateData(childProviderData, false);
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  /*
  invalidateData(providerData: any, playVideoInFull: boolean): Observable<any> {
    return super.invalidateData(providerData, playVideoInFull).pipe(
      switchMap( value => {
        if (value == null) {
          return of(null);
        }

        if (this.providerData["media:content"] != null) {
          value = this.providerData["media:content"][0].$.url;
          let aspectRatio = false;
          return this.playerService.caching.requestUrl(value, 'xml', Expiration.Minute).pipe(
            switchMap(path => {
              return this.genericElm.setMedia(path, aspectRatio, this.actualWidth, this.actualHeight, null, null).pipe(
                switchMap(r1 => {
                  return this.genericElm.play(false);
                })
              )
            })
          );
        }
        return of('item')
      })
    )
  }

   */
}

